import useMutation from "src/hooks/useMutation";

function useUserChangePassword(id) {
  return useMutation({
    path: `/api/v1/auth/change-password`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/users/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useUserChangePassword;
